import React from 'react';
export function FloatingCTA() {
  return null;
}